import * as React from "react";

function SvgSomedayIconBig(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={90}
      height={78}
      {...props}
    >
      <defs>
        <path
          d="M90.44 32.5v7.07H76.31c.22-1.15.31-2.34.31-3.53 0-1.2-.09-2.39-.31-3.54h14.13zM72.38 49.06L82.36 59l-4.99 5.03c-5.99-5.98-9.31-9.31-9.98-9.98 1.94-1.41 3.62-3.09 4.99-4.99m-4.99-31.04l9.98-9.98 4.99 5.03c-5.99 5.99-9.31 9.32-9.98 9.98a21.656 21.656 0 00-4.99-5.03m-12.98-4.2c-1.2 0-2.39.09-3.54.31V0h7.07v14.13a18.84 18.84 0 00-3.53-.31m16.25 22.22c0 5.34-2.61 10.06-6.54 13.02-1.32-1.9-2.91-3.57-4.72-4.99 2.65-1.68 4.46-4.63 4.46-8.03 0-5.22-4.24-9.45-9.45-9.45a9.49 9.49 0 00-8.44 5.16c-1.68-1.5-3.58-2.78-5.65-3.8 2.83-4.85 8.08-8.17 14.09-8.17 8.96 0 16.25 7.29 16.25 16.26M36.39 23.05l-9.98-9.98 4.99-5.03c6.01 5.99 9.35 9.31 10.02 9.98a22.644 22.644 0 00-5.03 5.03m18.72 38.2c0-5.21-4.1-8.96-10.2-9.45-.18-.01-1.11-.09-2.78-.22-.27-1.62-.41-2.51-.44-2.69-1.06-6.23-6.45-10.73-12.81-10.73-3.97 0-7.42 1.36-9.8 3.88-2.39 2.61-3.49 6.14-3.18 10.33.02.2.1 1.19.26 2.96-1.75.43-2.72.66-2.91.71-3.93 1.02-6.18 3.71-6.18 7.42 0 3.97 3.26 7.24 7.24 7.24h31.31c5.25 0 9.49-4.24 9.49-9.45m7.07 0c0 9.1-7.42 16.47-16.56 16.47H14.31C6.45 77.72 0 71.32 0 63.46c0-6.05 3.31-10.95 8.83-13.34.18-4.99 1.95-9.49 5.08-12.85 3.71-3.97 9.01-6.18 14.97-6.18 8.92 0 16.56 5.78 19.17 14.04 8.3 1.68 14.13 8.13 14.13 16.12"
          id="somedayIconBig_svg__a"
        />
      </defs>
      <use xlinkHref="#somedayIconBig_svg__a" fill="#ffc64e" />
      <use
        xlinkHref="#somedayIconBig_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
    </svg>
  );
}

export default SvgSomedayIconBig;
